import {ILicense} from '../components/card/types';

export const sortLicensesByActive = (licenses: ILicense[]) => {
    return licenses.sort((a: ILicense, b: ILicense) => {
        return (a.is_active === b.is_active) ? 0 : a.is_active ? -1 : 1;
    });
};
